export default {
  平台: '平台',
  加载中: '加载中...',
  登录密码: '登录密码',
  密码确认: '密码确认',
  导出: '导出',
  序列: '序列',
  操作人员: '操作人员',
  登录号: '登录号',
  机构关联用户: '机构关联用户',
  登录地址: '登录地址',
  所在单位: '所在单位',
  登录时间: '登录时间',
  ip地址: 'ip地址',
  登录方式: '登录方式',
  控件信息:'控件信息',
  输入:'输入',
  累计登录次数: '累计登录次数',
  角色别名: '角色别名',
  角色名称: '角色名称',
  角色类型: '角色类型',
  操作时间: '操作时间',
  基本信息: '基本信息',
  空间LOGO: '空间LOGO',
  请输入空间logo: '请输入空间logo',
  上传logo: '上传logo',
  常规logo的宽度: '常规logo的宽度',
  常规logo的高度: '常规logo的高度',
  空间名称: '空间名称',
  系统名称: '系统名称',
  空间简称: '空间简称',
  空间编码: '空间编码',
  描述: '描述',
  序号: '序号',
  请上传png格式或jpg格式: '请上传png格式或jpg格式',
  上传失败: '上传失败',
  空间管理信息: '空间管理信息',
  登录名: '登录名',
  网址: '网址',
  空间说明信息: '空间说明信息',
  空间类型: '空间类型',
  负责人: '负责人',
  默认pc空间: '默认pc空间',
  邮编: '邮编',
  电话: '电话',
  传真: '传真',
  取消: '取消',
  确定: '确定',
  修改: '修改',
  人员: '人员',
  部门: '部门',
  岗位: '岗位',
  角色: '角色',
  职务级别: '职务级别',
  编外人员: '编外人员',
  群组: '群组',
  子账号: '子账号',
  修改成功: '修改成功',
  授权信息: '授权信息',
  新增: '新增',
  新增人员: '新增人员',
  添加部门: '添加部门',
  添加: '添加',
  请输入: '请输入',
  请选择: '请选择',
  操作成功: '操作成功',
  编辑成功: '编辑成功',
  新增职务级别成功: '新增职务级别成功',
  批量删除: '批量删除',
  请选择需要删除的记录: '请选择需要删除的记录',
  您确定删除选择的记录吗: '您确定删除选择的记录吗',
  '职级导出.xlsx': '职级导出.xlsx',
  删除: '删除',
  关联用户: '关联用户',
  角色关联用户: '角色关联用户',
  编辑: '编辑',
  编辑职务级别成功: '编辑职务级别成功',
  职务级别名称: '职务级别名称',
  职务级别代码: '职务级别代码',
  职务级别序号: '职务级别序号',
  重复序号处理: '重复序号处理',
  插入: '插入',
  重复: '重复',
  启用状态: '启用状态',
  数据来源: '数据来源',
  状态: '状态',
  操作: '操作',
  岗位编码: '岗位编码',
  岗位名称: '岗位名称',
  岗位类别: '岗位类别',
  排序号: '排序号',
  请填写职务级别名称: '请填写职务级别名称',
  请填写职务级别代码: '请填写职务级别代码',
  请填写职务级别序号: '请填写职务级别序号',
  用户名称: '用户名称',
  用户账号: '用户账号',
  所在机构: '所在机构',
  组织架构: '组织架构',
  选择人员: '选择人员',
  新增机构成功: '新增机构成功',
  机构人员: '机构人员',
  编辑机构成功: '编辑机构成功',
  上级机构: '上级机构',
  机构名称: '机构名称',
  机构编码: '机构编码',
  机构主管: '机构主管',
  分管领导: '分管领导',
  机构管理员: '机构管理员',
  机构职能: '机构职能',
  机构级次: '机构级次',
  请选择上级机构: '请选择上级机构',
  请输入机构名称: '请输入机构名称',
  启用: '启用',
  停用: '停用',
  编辑角色成功: '编辑角色成功',
  控件编码: '控件编码',
  控件名称: '控件名称',
  请填写岗位编码: '请填写岗位编码',
  请填写岗位名称: '请填写岗位名称',
  请填写岗位类别: '请填写岗位类别',
  新增角色成功: '新增角色成功',
  新增成功: '新增成功',
  确认密码不一致: '确认密码不一致',
  请输入确认密码: '请输入确认密码',
  保存: '保存',
  授权成功: '授权成功',
  修改密码: '修改密码',
  切换用户: '切换用户',
  请输入密码: '请输入密码',
  子账号手机号: '子账号手机号',
  昵称: '昵称',
  密码: '密码',
  确认密码: '确认密码',
  用户角色: '用户角色',
  结算人员: '结算人员',
  日常业务人员: '日常业务人员',
  业务处理人员: '业务处理人员',
  浏览人员: '浏览人员',
  创建时间: '创建时间',
  请填写子账号: '请填写子账号',
  请选择用户角色: '请选择用户角色',
  请输入昵称: '请输入昵称',
  资源信息: '资源信息',
  输入资源名称: '输入资源名称',
  保存成功: '保存成功',
  角色信息: '角色信息',
  输入角色名称: '输入角色名称',
  输入控件名称: '输入控件名称',
  输入机构名称: '输入机构名称',
  机构信息: '机构信息',
  上级资源: '上级资源',
  上级资源名称: '上级资源名称',
  资源类型: '资源类型',
  菜单资源: '菜单资源',
  界面资源: '界面资源',
  打开方式: '打开方式',
  主界面: '主界面',
  资源名称: '资源名称',
  资源所属: '资源所属',
  客户界面: '客户界面',
  资源路径: '资源路径',
  图标: '图标',
  备注: '备注',
  url地址: 'url地址',
  字体图标: '字体图标',
  请输入资源名称: '请输入资源名称',
  请填写资源路径: '请填写资源路径',
  系统资源: '系统资源',
  菜单: '菜单',
  界面: '界面',
  默认角色: '默认角色',
  角色编码: '角色编码',
  请填写角色编码: '请填写角色编码',
  请填写角色名: '请填写角色名',
  确定将选择数据删除: '确定将选择数据删除',
  删除角色管理成功: '删除角色管理成功',
  查看用户: '查看用户',
  详情: '详情',
  平台下发: '平台下发',
  租户角色: '租户角色',
  是: '是',
  否: '否',
  权限设置: '权限设置',
  角色权限配置: '角色权限配置',
  接口权限: '接口权限',
  菜单权限: '菜单权限',
  请选择至少一项角色权限: '请选择至少一项角色权限',
  操作失败: '操作失败',
  当前仅支持选择一条数据: '当前仅支持选择一条数据',
  角色权限配置成功: '角色权限配置成功',
  上传头像成功: '上传头像成功',
  请填写确认密码: '请填写确认密码',
  确认密码与密码不一致: '确认密码与密码不一致',
  上传: '上传',
  姓名: '姓名',
  个人角色: '个人角色',
  所属机构: '所属机构',
  语言: '语言',
  英文: '英文',
  正式: '正式',
  人员状态: '正式',
  入职: '入职',
  离职: '离职',
  男: '男',
  女: '女',
  手机号: '手机号',
  邮箱: '邮箱',
  头像: '头像',
  人员角色: '人员角色',
  默认语言: '默认语言',
  请填写姓名: '请填写姓名',
  请填写登录名: '请填写登录名',
  请填写密码: '请填写密码',
  请选择角色: '请选择角色',
  请选择组织: '请选择组织',
  请填写排序号: '请填写排序号',
  请填写个人角色: '请填写个人角色',
  请填写所属机构: '请填写所属机构',
  租户: '租户',
  创建人: '创建人',
  系统环境: '系统环境',
  请求URI: '请求URI',
  '是一个基于Vue3.0、Vite、 Ant-Design-Vue 、TypeScript 的后台解决方案，目标是为中大型项目开发,提供现成的开箱解决方案及丰富的示例,原则上不会限制任何代码用于商用。':
    '是一个基于Vue3.0、Vite、 Ant-Design-Vue 、TypeScript 的后台解决方案，目标是为中大型项目开发,提供现成的开箱解决方案及丰富的示例,原则上不会限制任何代码用于商用。',
  最后编译时间: '最后编译时间',
  文档地址: '文档地址',
  预览地址: '预览地址',
  生产环境依赖: '生产环境依赖',
  开发环境依赖: '开发环境依赖',
  项目信息: '项目信息',
  关于: '关于',
  版本: '版本',
  每行显示数量: '每行显示数量',
  刷新: '刷新',
  是否确认删除: '是否确认删除',
  类型: '类型',
  总: '总',
  条: '条',
  上方插入行: '上方插入行',
  下方插入行: '下方插入行',
  复制: '复制',
  系统图标: '系统图标',
  输入名称关键字查询: '输入名称关键字查询',
  输入用户名称或者拼音进行查询: '输入用户名称或者拼音进行查询',
  选择用户: '选择用户',
  总数: '总数',
  搜索: '搜索',
  重置: '重置',
  '插槽 拖拽组件到此处': '插槽 拖拽组件到此处',
  内容标签切换: '内容标签切换',
  边框类型: '边框类型',
  有标题边框: '有标题边框',
  带边框: '带边框',
  无标题边框: '无标题边框',
  无边框: '无边框',
  更多: '更多',
  查询标签切换: '查询标签切换',
  标签名称: '标签名称',
  边框标题: '边框标题',
  宽度: '宽度',
  高度: '高度',
  '宽度可以是auto、100%，或者使用span：24宫格，或者是大于100的数字':
    '宽度可以是auto、100%，或者使用span：24宫格，或者是大于100的数字',
  '高度可以是auto、100%，或者是大于180的数字': '高度可以是auto、100%，或者是大于180的数字',
  圆角度: '圆角度',
  无: '无',
  小: '小',
  中: '中',
  大: '大',
  性别: '性别',
  人员类型: '人员类型',
  开启背景色: '开启背景色',
  背景色: '背景色',
  上下间距: '上下间距',
  左右间距: '左右间距',
  标题: '标题',
  标题显示: '标题显示',
  标题内容: '标题内容',
  左: '左',
  右: '右',
  Center: '中',
  标题位置: '标题位置',
  标签: '标签',
  显示: '显示',
  上: '上',
  Middle: '中',
  下: '下',
  面积颜色: '面积颜色',
  开启渐变: '开启渐变',
  图表标题: '图表标题',
  图形属性: '图形属性',
  柱体颜色: '柱体颜色',
  粗细: '粗细',
  位置: '位置',
  横行显示: '横行显示',
  竖向显示: '竖向显示',
  左倾斜显示: '左倾斜显示',
  右倾斜显示: '右倾斜显示',
  标签文字: '标签文字',
  图列: '图列',
  图列名称: '图列名称',
  列: '列',
  访问数: '访问数',
  总访问数: '总访问数',
  月: '月',
  显示标题: '显示标题',
  类型名称: '类型名称',
  数据格式: '数据格式',
  数字: '数字',
  美元: '美元',
  人民币: '人民币',
  小数位: '小数位',
  百分位: '百分位',
  千分位: '千分位',
  显示图标: '显示图标',
  图标大小: '图标大小',
  显示子标题: '显示子标题',
  显示子数量: '显示子数量',
  颜色: '颜色',
  全部应用: '全部应用',
  最近使用: '最近使用',
  我收藏的: '我收藏的',
  系统应用: '系统应用',
  应用宫格: '应用宫格',
  面积图: '面积图',
  柱状图: '柱状图',
  表格: '表格',
  动态数字: '动态数字',
  链接: '链接',
  折线图: '折线图',
  列表: '列表',
  标题属性: '标题属性',
  数字属性: '数字属性',
  默认值: '默认值',
  前缀: '前缀',
  后缀: '后缀',
  字体大小: '字体大小',
  字体颜色: '字体颜色',
  饼图: '饼图',
  流程统计: '流程统计',
  任务中心: '任务中心',
  我的待办: '我的待办',
  我的申请: '我的申请',
  我的抄送: '我的抄送',
  我的处理: '我的处理',
  待办列表: '待办列表',
  '研发部：魏勇【架构师】': '研发部：魏勇【架构师】',
  '审批节点【李总】': '审批节点【李总】',
  查看详情: '查看详情',
  流程待办: '流程待办',
  摆放位置: '摆放位置',
  左侧: '左侧',
  交替展现: '交替展现',
  右侧: '右侧',
  时间轴信息说明: '时间轴信息说明',
  时间轴: '时间轴',
  内容: '内容',
  '自由布局模式下，请保留至少1个栏目！': '自由布局模式下，请保留至少1个栏目！',
  记录内容: '记录内容',
  简单列表: '简单列表',
  平台运营: '平台运营',
  平台公告: '平台公告',
  公告类型: '公告类型',
  公告内容: '公告内容',
  公告日期: '公告日期',
  描述信息: '描述信息',
  标题信息: '标题信息',
  用户头像: '用户头像',
  用户图标带内容: '用户图标带内容',
  您确定删除该记录: '您确定删除该记录',
  信息标题: '信息标题',
  图片: '图片',
  用户说明信息编辑: '用户说明信息编辑',
  请拖拽组件到此处: '请拖拽组件到此处',
  组织成员: '组织成员',
  成员: '成员',
  角色成员: '角色成员',
  已选择: '已选择',
  全部: '全部',
  管理类: '管理类',
  其他: '其他',
  您确定重置选择的密码吗: '您确定重置选择的密码吗',
  重置密码: '重置密码',
  组织模型模块: '组织模型模块',
  资源权限中心: '资源权限中心',
  系统日志: '系统日志',
  应用现代化平台: '应用现代化平台',
  查看应用说明: '查看应用说明',
  分享应用: '分享应用',
  '地址复制成功！': '地址复制成功！',
  账套管理: '账套管理',
  子账号管理: '子账号管理',
  部门管理: '部门管理',
  岗位管理: '岗位管理',
  角色管理: '角色管理',
  人员管理: '人员管理',
  职务级别管理: '职务级别管理',
  系统资源管理: '系统资源管理',
  系统资源权限管理: '系统资源权限管理',
  登录日志: '登录日志',
  错误日志: '错误日志',
  流程: '流程',
  用户信息: '用户信息',
  错误提示: '错误提示',
  信息提示: '信息提示',
};
